/* Jennifer Ann's facelift. Built by C2C Digital. */
(function () {
  function tidyEvents(root) {
    var groups = {};
    root.querySelectorAll('.sk-event-item').forEach(function (item) {
      var t = item.querySelector('.sk-event-item-title');
      if (!t) return;
      var key = t.textContent.trim().toLowerCase();
      (groups[key] = groups[key] || []).push(item);
    });
    Object.keys(groups).forEach(function (k) {
      var g = groups[k];
      if (g.length < 3) return;
      var first = g[0];
      if (!first.dataset.jabMerged) {
        var a = first.querySelector('.sk-event-item-date time, .sk-event-item-date');
        if (a) {
          var re = /\s+\d{1,2}:\d{2}.*$/;
          var start = a.textContent.trim().replace(re, '');
          var hours = (a.textContent.trim().match(/\d{1,2}:\d{2}.*$/) || [''])[0];
          a.textContent = 'Every day starting ' + start + (hours ? ', ' + hours : '');
        }
        first.dataset.jabMerged = '1';
      }
      g.slice(1).forEach(function (x) { x.style.display = 'none'; });
    });
  }

  function tidyPosts(root) {
    root.querySelectorAll('.sk-post-item').forEach(function (post) {
      var hasImg = post.querySelector('.sk-post-media.--image img, .post-image-src');
      var text = post.querySelector('.sk-post-body-full, .sk-post-body-short');
      var hasText = text && text.textContent.trim().length > 40;
      if (!hasImg && !hasText) post.style.display = 'none';
    });
  }

  var queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('.sk-fb-event').forEach(tidyEvents);
    document.querySelectorAll('.sk-ww-facebook-page-posts').forEach(tidyPosts);
  }
  function queue() { if (!queued) { queued = true; setTimeout(run, 150); } }

  if (document.querySelector('.sk-fb-event, .sk-ww-facebook-page-posts')) {
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    queue();
  }
})();
